import { render } from "./index.vue?vue&type=template&id=53f11802&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=53f11802&lang=scss&scoped=true"

import exportComponent from "C:\\xiangmu\\gas-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f11802"]])

export default __exports__